import React, { useState, useRef, useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import "../../../css/PaginaProducto/ProductoEspecifico.css"
import { CSSTransition } from 'react-transition-group';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

/* imagenes */
import logo1 from "../../../Image/producto-hod-41.png"
import logo2 from "../../../Image/producto-hod-42.png"
import logo3 from "../../../Image/producto-hod-43.png"
import logo4 from "../../../Image/producto-hod-44.png"
import logo5 from "../../../Image/producto-hod-63.png"
import logo6 from "../../../Image/producto-hod-64.png"
import logo7 from "../../../Image/producto-hod-65.png"
import logo8 from "../../../Image/producto-hod-66.png"
import logo9 from "../../../Image/producto-hod-67.png"
import logo10 from "../../../Image/producto-hod-68.png"
import logo11 from "../../../Image/producto-hod-69.png"
import logo12 from "../../../Image/producto-hod-70.png"
import logo13 from "../../../Image/iconos-dispensing-hod-102.png"
import logo14 from "../../../Image/iconos-dispensing-hod-103.png"
import logo15 from "../../../Image/iconos-dispensing-hod-104.png"
import axios from "axios";





const iconosMorado = [
  { nombre: 'CARACTERÍSTICAS', image: logo1 },
  { nombre: 'BENEFICIOS', image: logo2 },
  { nombre: 'CAPACIDADES', image: logo3 },
  { nombre: 'DISPOSITIVOS', nombre1: 'COMPATIBLES', image: logo4 },
];

const iconosNaranjo = [
  { nombre: 'CARACTERÍSTICAS', image: logo9 },
  { nombre: 'BENEFICIOS', image: logo10 },
  { nombre: 'CAPACIDADES', image: logo11 },
  { nombre: 'DISPOSITIVOS', nombre1: 'COMPATIBLES', image: logo12 },
];


const iconosVerde = [
  { nombre: 'CARACTERÍSTICAS', image: logo5 },
  { nombre: 'BENEFICIOS', image: logo6 },
  { nombre: 'CAPACIDADES', image: logo7 },
  { nombre: 'DISPOSITIVOS', nombre1: 'COMPATIBLES', image: logo8 },
];

const iconosAzul = [
  { nombre: 'CARACTERÍSTICAS', image: logo13 },
  { nombre: 'BENEFICIOS', image: logo14 },
  { nombre: 'CAPACIDADES', image: logo15 },

];
export const DescripcionProducto = ({ producto, categoria }) => {
  const [activo, setActivo] = useState(0);
  const colorCategoria = (categoria && categoria.color) ? categoria.color : "#6A3090";
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  let iconos = [];
  const nodeRef = useRef(null);
  const [mostrarContenido, setMostrarContenido] = useState(true);

  console.log("prodcuto", producto.pdf)

  const handleDescargar = () => {
    if (producto.pdf) {
      const url = `${backendURL}/${producto.pdf}`;
      window.open(url, '_blank');
    }
  };

  const descargar = async () => {
    if (!producto.id) return;

    try {
      const url = `${backendURL}/api/producto/${producto.id}/descargar-pdf`;

      const response = await axios.get(url, {
        responseType: 'blob', // importante para archivos binarios
      });
      handleDescargar();
      // Crear un blob con el tipo correcto
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Crear un enlace para descargar
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(pdfBlob);

      // Nombre del archivo (puedes personalizarlo)
      link.download = 'ficha-tecnica.pdf';

      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error al descargar PDF:', error);
    }
  };

  useEffect(() => {
    setMostrarContenido(false);
    const timeout = setTimeout(() => setMostrarContenido(true), 50);
    return () => clearTimeout(timeout);
  }, [activo]);

  if (categoria.color === '#6A3090') {
    iconos = iconosMorado;
  } else if (categoria.color === '#FFA457') {
    iconos = iconosNaranjo;
  } else if (categoria.color === '#00A69E') {
    iconos = iconosVerde;
  }
  else if (categoria.color === '#1A425B') {
    iconos = iconosAzul;
  }
  const caracteristicas = [
    producto.caracteristica,
    producto.caracteristica1,
    producto.caracteristica2,
    producto.caracteristica3,
    producto.caracteristica4,
    producto.caracteristica6,
  ].filter(Boolean);

  const beneficios = [
    producto.beneficio,
    producto.beneficio1,
    producto.beneficio2,
    producto.beneficio3,
    producto.beneficio4,
    producto.beneficio5,
    producto.beneficio6,
  ].filter(Boolean);

  const capacidades = [
    producto.capacidad,
    producto.capacidad1,
    producto.capacidad2,
    producto.capacidad3,
    producto.capacidad4,
    producto.capacidad5,
    producto.capacidad6,
    producto.capacidad7,
    producto.capacidad8,
  ].filter(Boolean);

  const accesorios = [
    producto.imagen_dispositivo,
    producto.imagen_dispositivo1,
    producto.imagen_dispositivo2,
    producto.imagen_dispositivo3,
    producto.imagen_dispositivo4,
    producto.imagen_dispositivo5,
    producto.imagen_dispositivo6,
    producto.imagen_dispositivo7,
  ].filter(Boolean);

  const telemetria = [
    producto.logo_dispositivo,
    producto.logo_dispositivo1,
  ].filter(Boolean);

  const renderContenido = () => {
    switch (activo) {
      case 0: // Características
        return (
          <ul style={{ listStyle: "none", paddingLeft: 0 }}>
            {caracteristicas.map((item, i) => (
              <li className="descripciondetalladomaquina" key={i} >
                <span style={{ color: producto.color || '#1A425B', marginRight: "6px" }}>▶</span>
                {item}
              </li>
            ))}
          </ul>
        );
      case 1: // Beneficios
        return (
          <ul style={{ listStyle: "none", paddingLeft: 0 }}>
            {beneficios.map((item, i) => (
              <li className="descripciondetalladomaquina" key={i} >
                <span style={{ color: producto.color || '#1A425B', marginRight: "6px" }}>▶</span>
                {item}
              </li>
            ))}
          </ul>
        );
      case 2: // Capacidades
        return (
          <ul style={{ listStyle: "none", paddingLeft: 0 }}>
            {capacidades.map((item, i) => (
              <li className="descripciondetalladomaquina" key={i} >
                <span style={{ color: producto.color || '#1A425B', marginRight: "6px" }}>▶</span>
                {item}
              </li>
            ))}
          </ul>
        );
      case 3: // Dispositivos compatibles (imágenes)
        return (
          <Box sx={{
            mt: 6, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-around', gap: 2, '@media (max-width:1002px)': {
              gap: 3,
            }, '@media (max-width:500px)': {
              alignItems: 'center',
              flexDirection: 'column'
            }
          }}>
            {/* Accesorios */}
            {accesorios.length > 0 && (
              <Box >
                <Typography variant="h6" sx={{ textAlign: "center", mb: 2, color: '#1A425B', fontWeight: '600', fontFamily: 'Montserrat' }}>
                  Accesorios
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    justifyContent: "center",
                    mb: 4,
                    '@media (max-width:600px)': {
                      gap: 1,
                      display: 'flex',
                      alignItems: 'center', flexDirection: 'column', justifyContent: 'center'
                    },

                  }}
                >
                  <Grid container spacing={2} sx={{display:'flex', alignItems:"center", justifyContent:'center'}}>
                  {accesorios.map((imgUrl, i) => (
                    
                      <Grid size={{xs:12, sm:6, md:4, lg:3, xl:2}} key={i} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                        <Box sx={{ width:'100%' }}>
                      <img
                        src={`${backendURL}/${imgUrl}`}
                        alt={`Accesorio ${i + 1}`}
                        width="100%"
                      />
                    </Box>
                      </Grid>
                  ))} 
                   </Grid>
                </Box>
              </Box>
            )}

            {/* Telemetría */}
            {telemetria.length > 0 && (
              <Box>
                <Typography variant="h6" sx={{ textAlign: "center", mb: 2, color: '#1A425B', fontWeight: '600', fontFamily: 'Montserrat' }}>
                  Telemetría
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    justifyContent: "center",
                    '@media (max-width:600px)': {
                      gap: 1,
                      display: 'flex',
                      alignItems: 'center', flexDirection: 'column', justifyContent: 'center'
                    },
                  }}
                >

                  <Grid container sx={{display:'flex', alignItems:"center", justifyContent:'center'}}>
                  {telemetria.map((imgUrl, i) => (
                    
                      <Grid size={{xs:12, sm:6,  }} key={i} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                        <Box sx={{ width:'50%' }}>
                      <img
                        src={`${backendURL}/${imgUrl}`}
                        alt={`Accesorio ${i + 1}`}
                        width="100%"
                      />
                    </Box>
                      </Grid>
                  ))} 
                   </Grid>

                </Box>
              </Box>
            )}
          </Box>
        );
      default:
        return null;
    }
  };

  const hayContenido =
  caracteristicas.length > 0 ||
  beneficios.length > 0 ||
  capacidades.length > 0 ||
  accesorios.length > 0 ||
  telemetria.length > 0;
  return (
    <Box>
        {hayContenido && (
      <div className="contenedor-steps">
        {iconos.map((item, index) => (
          <>
            <Box
              key={index}
              className={`step-item ${activo === index ? 'activo' : ''}`}
              onClick={() => setActivo(index)}
              sx={{
                backgroundColor: activo === index ? '#f3f3f3' : 'transparent',
                borderRadius: activo === index ? `10px 10px 0px 0px` : '0px',
                cursor: 'pointer',
                flex: 1,
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                color: activo === index ? colorCategoria : '#333',
                py: 2,
                '@media (max-width:350px)': {
                  padding: '10px'
                },
              }}
            >
              <Box className='imagenstepprodcuto'>
                <img src={item.image} alt={item.nombre} width='100%' />
              </Box>

              <Box
                sx={{ mt: 2, display: "flex", alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <Typography variant="subtitle1"
                  sx={{
                    mt: 1, fontWeight: '700', fontFamily: 'Montserrat', color: colorCategoria, margin: 0, '@media (max-width:700px)': {
                      fontSize: '0.8rem'
                    }, '@media (max-width:500px)': {
                      fontSize: '0.5rem'
                    },
                  }}>
                  {item.nombre}
                </Typography>
                {item.nombre1 && (
                  <Typography variant="subtitle1"
                    sx={{
                      mt: 1, fontWeight: '700', fontFamily: 'Montserrat', color: colorCategoria, marginTop: '-6px', '@media (max-width:700px)': {
                        fontSize: '0.8rem'
                      }, '@media (max-width:500px)': {
                        fontSize: '0.5rem'
                      },
                    }}>
                    {item.nombre1}
                  </Typography>
                )}
              </Box>
            </Box>
          </>
        ))}

      </div>
        )}
      <CSSTransition
        in={mostrarContenido}
        timeout={1000}
        classNames="slide"
        unmountOnExit
        nodeRef={nodeRef}
      >
        <div ref={nodeRef} style={{ marginTop: '50px' }}>
          <Typography
            variant="body1"
            component="div"
            sx={{
              fontFamily: "Montserrat",

              lineHeight: "1.6",
            }}
          >
            {renderContenido()}
          </Typography>
        </div>
      </CSSTransition>

      <Box
        sx={{
          mt: 20,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        {producto.pdf && (
          <button
            onClick={descargar}
            className="anchobotondescarga"
            style={{
              '--boton-color': producto.color || '#1A425B',
            }}
          >
            <SaveAltIcon sx={{ marginRight: '10px', fontSize: '2rem' }} />
            <p style={{ margin: 0 }}>Descargar ficha técnica</p>
          </button>
        )}
      </Box>
      
    </Box>
  )
}